import i18n from 'i18n'
import ContentLoader from 'react-content-loader'
import { IContentLoaderProps } from 'react-content-loader'
import { theme } from 'theme'

const WhatsNewPostsLoader = (props: IContentLoaderProps) => {
  return (
    <ContentLoader
      height={1140}
      width={'100%'}
      viewBox="0 0 640 1140"
      backgroundColor={theme.palette.surface.subtle}
      foregroundColor={theme.palette.border.primary}
      style={{ transform: i18n.dir() === 'rtl' ? 'scaleX(-1)' : undefined }}
      {...props}
    >
      <rect x="0" y="20" rx="18" ry="18" width="640" height="360" />
      <rect x="160" y="432" rx="10" ry="10" width="320" height="52" />
      <rect x="60" y="520" rx="8" ry="8" width="520" height="22" />
      <rect x="88" y="554" rx="8" ry="8" width="464" height="22" />
      <rect x="110" y="588" rx="8" ry="8" width="420" height="22" />

      <rect x="68" y="650" rx="8" ry="8" width="12" height="12" />
      <rect x="92" y="644" rx="8" ry="8" width="460" height="22" />
      <rect x="68" y="686" rx="8" ry="8" width="12" height="12" />
      <rect x="92" y="680" rx="8" ry="8" width="430" height="22" />

      <rect x="24" y="744" rx="1" ry="1" width="592" height="1" />

      <rect x="0" y="796" rx="18" ry="18" width="640" height="250" />
      <rect x="180" y="1074" rx="10" ry="10" width="280" height="40" />
    </ContentLoader>
  )
}

export default WhatsNewPostsLoader
